export default {
  methods: {
    transformLangCode(code) {
      return `${code}-${code.toUpperCase()}`;
    },
  },
};
